var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "draggable",
        {
          attrs: {
            group: `categoryGroup-${_vm.parentCategorySlug}`,
            options: { handle: ".handle" },
          },
          on: {
            start: function ($event) {
              _vm.drag = true
            },
            end: function ($event) {
              _vm.drag = false
            },
            update: _vm.updateCategoriesOrder,
          },
          model: {
            value: _vm.categories,
            callback: function ($$v) {
              _vm.categories = $$v
            },
            expression: "categories",
          },
        },
        _vm._l(_vm.categories, function (cate) {
          return _vm.deletedCateSlugs.includes(cate.slug) === false
            ? _c(
                "div",
                { key: cate.slug, staticClass: "list-box" },
                [
                  _vm.hasEditorRole
                    ? _c("button", { staticClass: "button is-small handle" }, [
                        _c("span", { staticClass: "icon is-small" }, [
                          _c("i", { staticClass: "fas fa-sort" }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "u-clickable list-label has-text-black",
                      on: {
                        click: function ($event) {
                          return _vm.toggleBlock(cate.slug)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v(_vm._s(cate.label))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon is-pulled-right" }, [
                        _vm.activeCateSlugs.includes(cate.slug)
                          ? _c("i", { staticClass: "fas fa-angle-up" })
                          : _c("i", { staticClass: "fas fa-angle-down" }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.activeCateSlugs.includes(cate.slug)
                    ? _c("ul", { staticClass: "is-flex mb-3" }, [
                        _vm.hasEditorRole
                          ? _c(
                              "li",
                              { staticClass: "mr-5" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "icon-text is-size-6i has-text-grey",
                                    attrs: {
                                      to: {
                                        path: `/admin/categories/${_vm.serviceId}/create`,
                                        query: { parent: cate.slug },
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", { staticClass: "fas fa-plus" }),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("common.add"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasEditorRole
                          ? _c(
                              "li",
                              { staticClass: "mr-5" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "icon-text is-size-6 has-text-grey",
                                    attrs: {
                                      to: `/admin/categories/${_vm.serviceId}/${cate.slug}/edit`,
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", { staticClass: "fas fa-edit" }),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("common.edit"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasEditorRole
                          ? _c("li", { staticClass: "mr-5" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "u-clickable icon-text is-size-6 has-text-grey",
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDeleteCategory(
                                        cate.slug
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", { staticClass: "fas fa-trash" }),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.delete"))),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "mr-5" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "u-clickable icon-text is-size-6 has-text-grey",
                                attrs: {
                                  to: {
                                    path: `/admin/posts/${_vm.serviceId}`,
                                    query: { category: cate.slug },
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.posts")))]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeCateSlugs.includes(cate.slug)
                    ? _c("category-list-recursive", {
                        attrs: { "parent-category-slug": cate.slug },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e()
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }